export const getCountries = state => state.countries;
export const getCountry = state => state.country;
export const getLocations = state => state.locations;



// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/vuex/search/getters.js